import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { closeIntercomConnection } from '@/utils/intercom';
import { removeToken } from '@/utils/token';
import { logout } from '@/features/auth/utils/loginSlice';

export default function useLogout({ redirectTo = '/login' } = {}) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return () => {
    queryClient.clear();
    removeToken();
    localStorage.removeItem('clouderType');
    closeIntercomConnection();
    dispatch(logout());
    navigate(redirectTo);
  };
}
